import { render, staticRenderFns } from "./FormatObjectDrawer.vue?vue&type=template&id=2d941118&"
import script from "./FormatObjectDrawer.vue?vue&type=script&lang=ts&"
export * from "./FormatObjectDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports